<template>
  <div class="safety-map-box">
    <baidu-map
      class="map-Box"
      v-if="mapCenter"
      :center="mapCenter"
      :zoom="mapZoom"
      :minZoom="5"
      :maxZoom="14"
      :mapClick="false"
      :scrollWheelZoom="true"
    >
        <transition name="el-zoom-in-top">
      <div v-show="showSchoolType" class="show-list-name">
        <div
          v-for="(item, index) in schoolType"
          :key="index"
          class="show-list-name-item"
          @click="schoolTypeClick(item.value)"
          :style="
            index == 0
              ? 'margin-top:45px;' +
                'background: url(' +
                require('@/assets/img/baiduMapIcon/search-type-all.png') +
                ');background-size: 100% 100%;'
              : '' +
                'background: url(' +
                require('@/assets/img/baiduMapIcon/search-type-' +
                  item.value +
                  '.png') +
                ');background-size: 100% 100%;'
          "
        ></div>
      </div>
        </transition>
      <img
        class="show-name"
        src="@/assets/img/baiduMapIcon/school-type-search.png"
        @click="showSchoolType = !showSchoolType"
      />
      <bm-boundary
        class="safety-map-boundary"
        :name="mapCenter"
        :strokeWeight="2"
        strokeColor="green"
        fillColor="rgba(255,255,255,0.6)"
      >
      </bm-boundary>
      <div
        class="safety-map-list"
        v-for="(item, index) of markerLists"
        :key="index"
      >
        <bm-marker
          :position="item.markerPo"
          :title="item.eduBuresuName"
          :zIndex="index"
          @click="infoWindowOpen(item, index)"
          :icon="{
            url: item.type == 'school' ? schoolIcon : educationIcon,
            size: { width: 40, height: 74 }
          }"
        >
          <bm-label
            v-if="showName"
            :content="item.eduBuresuName"
            :labelStyle="{
              color: '#2B2D39',
              fontSize: '14px',
              fontWeight: '600',
              border: 'none',
              background: 'transparent'
            }"
            :offset="{ width: -22, height: 40 }"
          ></bm-label>
          <bm-info-window
            :position="item.markerPo"
            :show="item.showInfoWindow"
            @close="infoWindowClose(item, index)"
            @open="infoWindowOpen(item, index)"
          >
            <school-bm-info-window
              v-if="item.type == 'school'"
              :info="infoWindowInfo"
            ></school-bm-info-window>
            <edu-bm-info-window
              v-else
              :info="infoWindowInfo"
            ></edu-bm-info-window>
          </bm-info-window>
        </bm-marker>
      </div>
      <div class="icon-remark">
        <div class="icon-box">
          <div class="edu-icon-box"></div>
          <div>教育局</div>
        </div>
        <div class="icon-box">
          <div class="school-icon-box"></div>
          <div>学校</div>
        </div>
      </div>
    </baidu-map>
  </div>
</template>
<script>
import Vue from "vue";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmView from "vue-baidu-map/components/map/MapView"; //地图视图
import BmLocalSearch from "vue-baidu-map/components/search/LocalSearch"; //搜索
import BmMarker from "vue-baidu-map/components/overlays/Marker"; //点标注
import BmLabel from "vue-baidu-map/components/overlays/Label"; //点标注label
import BmInfoWindow from "vue-baidu-map/components/overlays/InfoWindow"; //标注弹窗
import schoolBmInfoWindow from "./schoolBmInfoWindow"; //学校弹窗标注
import eduBmInfoWindow from "./eduBmInfoWindow"; //教育局弹窗标注
import mapStyleJson from "./MapStyleJson";

export default {
  name: "baiDuMapVue",
  components: {
    BaiduMap,
    BmView,
    BmLocalSearch,
    BmMarker,
    BmLabel,
    BmInfoWindow,
    schoolBmInfoWindow,
    eduBmInfoWindow
  },
  props: {
    markerList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    center: {
      type: String,
      default: {
        return: ""
      }
    },
    mapZoom: {
      trpe: Number,
      default: {
        return: 8
      }
    }
  },
  data() {
    return {
      schoolIcon: require("@/assets/img/baiduMapIcon/map-school-icon-s.png"), //标注图标(学校)
      // educationIcon: require("@/assets/img/baiduMapIcon/map-school.png"), //标注图标(教育局)
      educationIcon: require("@/assets/img/baiduMapIcon/map-edu-icon-s.png"),
      showName: false,
      showSchoolType: false,
      schoolType: [
        { name: "全部", value: "all" },
        { name: "所有教育局", value: 0 },
        { name: "所有学校", value: 1 },
        { name: "幼儿园", value: 2 },
        { name: "小学", value: 3 },
        { name: "初中", value: 4 },
        { name: "高中", value: 5 },
        { name: "完全中学", value: 6 },
        { name: "九年一贯制学校", value: 7 },
        { name: "九年一贯制高中", value: 8 },
        { name: "大学", value: 9 },
        { name: "职业学校", value: 10 },
        { name: "中等专业学校", value: 11 },
        { name: "技工学校", value: 12 },
        { name: "其他", value: 13 }
      ],
      // mapStyle:{style:'midnight'},
      mapStyle: {
        styleJson: mapStyleJson
        // style : "midnight"
      },
      markerLists: [],
      mapCenter: "",
      infoWindowInfo: {
        basicInformationOfEducationBureaus: {
          eduBuresuName: "",
          contactAddress: ""
        }
      },
      list: this.schoolAndEduList
    };
  },
  mounted() {},
  methods: {
    // 弹框关闭
    infoWindowClose(item, index) {
      this.markerLists[index].showInfoWindow = false;
      this.infoWindowInfo = {};
    },
    // 点击图标
    infoWindowOpen(item, index) {
      let obj = this.markerLists[index];
      if (!obj.showInfoWindow) {
        obj.showInfoWindow = true;
        Vue.set(this.markerLists, index, obj);
        if (obj.type == "school") {
          // 当前点击的是学校
          this.getSchoolInfo(obj);
        } else {
          // 当前点击的是教育局
          this.getEduInfo(obj);
        }
        this.$emit("mapClickMarker", obj);
      }
    },
    async getEduInfo(val) {
      let req = {
        eduId: parseInt(val.eduId),
        regionCode: parseInt(val.regionCode),
        eduBureauType: parseInt(val.eduBuresuType)
      };
      let self = this;
      let res = await self.$Http.getEduDetails(req);
      if (res.code == 200) {
        if (res.data) {
          self.infoWindowInfo = res.data[0] || {};
        }
      } else if (res.code == 101) {
      } else {
      }
    },
    async getSchoolInfo(val) {
      let req = {
        schoolId: parseInt(val.schoolId)
      };
      let self = this;
      let res = await self.$Http.getSchoolDetails(req);
      if (res.code == 200) {
        if (res.data) {
          self.infoWindowInfo = res.data[0] || {};
        }
      } else if (res.code == 101) {
      } else {
      }
    },
    schoolTypeClick(val) {
      if (val == "all") {
        this.markerLists = this.markerList;
        this.showName = false;
      } else if (val == 0) {
        //   所有教育局
        this.markerLists = this.markerList.filter((item) => {
          return item.type == "edu";
        });
        this.showName = true;
      } else if (val == 1) {
        //   所有学校
        this.markerLists = this.markerList.filter((item) => {
          return item.type == "school";
        });
        this.showName = true;
      } else {
        let num = val - 2;
        this.showName = true;
        this.markerLists = this.markerList.filter((item) => {
          return item.schoolCategory == num && item.type == "school";
        });
      }
      if (this.markerLists.length > 0) {
        this.$emit("mapClickMarker", this.markerLists[0]);
      }
    }
  },
  watch: {
    markerList: {
      handler(newName, oldName) {
        // this.markerLists = newName.filter((item)=>{
        //    return item.type == 'edu'
        // })
        this.$nextTick(() => {
          //   this.loadChart();
          this.showName = false;
          this.markerLists = [];
          this.markerLists = newName;
        });
      },
      immediate: true,
      deep: true
    },
    center: function(val) {
      if (val) {
        this.mapCenter = val;
      }
    },
    schoolAndEduList: {
      handler(nval, oval) {
        this.list = nval;
      }
    }
  },
  computed: {
    schoolAndEduList() {
      return this.$store.state.schoolAndEduList;
    }
  }
};
</script>
<style lang="scss" scoped>
.map-Box {
  margin: 0px 0px 0px 70px;
  height: 820px;
  position: relative;
  /* width: calc(100% - 100px);
    height: calc(100% - 20px); */
  .show-name {
    color: #d7e0b6;
    cursor: pointer;
    position: absolute;
    top: 30px;
    right: 30px;
    margin: 0px 5px;
    width: 123px;
    transition: transform 0.3s;
    &:hover {
      transform: scale(1.05);
    }
  }
  .show-list-name {
    color: #d7e0b6;
    cursor: pointer;
    position: absolute;
    top: 30px;
    right: 30px;
    width: 133px;
    height: 680px;
    background: url("~@/assets/img/baiduMapIcon/search-pull-down.png");
    background-size: 100% 100%;
    transition: transform 0.3s;
    .show-list-name-item {
      width: 105px;
      height: 30px;
      margin: 12px 14px;
      &:hover {
        transform: scale(1.05);
      }
    }
  }
}
.safety-map-box {
  /deep/ .map-Box {
    .BMap_pop {
      div {
        border: none !important;
        background-color: transparent !important;
      }
      > div {
        img {
          display: none;
        }
      }
      .BMap_top,
      .BMap_bottom {
        display: none;
      }
      .BMap_center {
        display: block;
        background: transparent;
      }
    }
    .anchorBL {
      display: none;
    }
    .BMap_shadow img {
      opacity: 0;
    }
  }
}
.icon-remark {
  position: absolute;
  left: 30px;
  bottom: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  .icon-box {
    width: 60px;
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    pointer-events: none;
  }
  .edu-icon-box{
    width: 40px;
    height: 40px;
    background: url("~@/assets/img/baiduMapIcon/map-edu-icon.png");
    background-size: 100% 100%;
  }
  .school-icon-box{
    width: 40px;
    height: 40px;
    background: url("~@/assets/img/baiduMapIcon/map-school-icon.png");
    background-size: 100% 100%;
  }
}
</style>
